export const validTabs = ["general", "members", "invites"] as const;

export type OrganizationTab = (typeof validTabs)[number];
